import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import useAuthUtils from "../../../../../../../hooks/auth/useAuthUtils";
import { url_105 } from "../../../../../../../custom_utilities/api_services";
import usePyqRedux from "./usePyqRedux";

export const useGetPyqYears = () => {
  const { headers, startLoading, finishLoading } = useAuthUtils();
  const { pyqCurrentYear, setPyqCurrentYear } = usePyqRedux();

  const fetchPyqYears = async () => {
    try {
      startLoading();

      const response = await axios.get(url_105, { headers });
      if (response.data.status === 200) {
        if (!pyqCurrentYear) {
          setPyqCurrentYear(response?.data?.data[0].year);
        }
        return response?.data?.data;
      }
      return [];
    } catch (err) {
      console.log(err);
    } finally {
      finishLoading();
    }
  };

  return useQuery({
    queryKey: ["pyq-years"],
    queryFn: fetchPyqYears,
  });
};
